import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/not-found';
import { PageSpinner } from 'src/components/spinner-container';
import { useCognitoUser } from 'src/hooks/use-cognito';
import { useOptionalMonolithCurrentUser } from 'src/hooks/use-monolith-user';
import { AggregateEuCentralBuyer } from 'src/pages/aggregate-eu/central-buyer';
import { AggregateEuContracts } from 'src/pages/aggregate-eu/contracts';
import AggregateEuDemandsPage from 'src/pages/aggregate-eu/demands';
import { AggregateEuGuest } from 'src/pages/aggregate-eu/guest';
import { AggregateEuOverview } from 'src/pages/aggregate-eu/overview';
import { AggregateEuServiceSettings } from 'src/pages/aggregate-eu/service-settings';
import { AggregateEuTenderingAndMatching } from 'src/pages/aggregate-eu/tendering-and-matching';
import { useAggregateEuRoot } from 'src/pages/aggregate-eu/use-aggregate-eu-root';

export const AggregateEu = () => {
  const auth = useOptionalMonolithCurrentUser();
  const user = useCognitoUser();
  const isAuthenticated = Boolean(auth || user.data);
  if (isAuthenticated) return <AggregateEuAuthenticated />;

  return <AggregateEuGuest />;
};

const AggregateEuAuthenticated = () => {
  const aggregateEuRootRequest = useAggregateEuRoot();

  if (!aggregateEuRootRequest?.response) {
    return <PageSpinner />;
  }

  return (
    <Switch>
      <Route path="/aggregate-eu" exact>
        <Redirect to="/aggregate-eu/overview" />
      </Route>
      <Route path="/aggregate-eu/overview">
        <AggregateEuOverview aggregateEuRootRequest={aggregateEuRootRequest} />
      </Route>
      <Route path="/aggregate-eu/demands">
        <AggregateEuDemandsPage
          aggregateEuRootRequest={aggregateEuRootRequest}
        />
      </Route>
      <Route path="/aggregate-eu/tendering-and-matching">
        <AggregateEuTenderingAndMatching
          aggregateEuRootRequest={aggregateEuRootRequest}
        />
      </Route>
      <Route path="/aggregate-eu/contracts">
        <AggregateEuContracts />
      </Route>
      {aggregateEuRootRequest.response.data._links?.consortia && (
        <Route path="/aggregate-eu/central-buyer">
          <AggregateEuCentralBuyer
            aggregateEuRootRequest={aggregateEuRootRequest}
          />
        </Route>
      )}
      <Route path="/aggregate-eu/service-settings">
        <AggregateEuServiceSettings />
      </Route>
      <Route>
        <ThrowNotFound />
      </Route>
    </Switch>
  );
};
